import { Grid, Link, TextField } from "@mui/material";
import  { useEffect, useState } from "react";
import Styles from "../styles/main.module.css";
import SettlementTable from "./SettlementTable";
import logo from "../../../../images/Group 1000000833.png";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Loader from "../../../../Loader/Loader";
import { useStateValue } from "../../../../Hooks/stateProvider";
import { ls } from "../../../../variables";
import { encrypt } from "../../../../utils/cipher";
import { previewValidators } from "../../../../utils/validators";
import SelectComponent from "../../../../components/SelectComponent";
import { errorHandler } from "../../../../utils/errorHandling";

const SettlementPage = () => {
  // const classes = useStyles()

  const pmsName = ls.get("pmsName");
  const [{ pageLoading, fy_year, quarter, moduleType }, dispatch] = useStateValue();
  const [selectedFinancialYear, setSelectedFinancialYear] = useState(fy_year);
  const [selectedQuarter, setSelectedQuarter] = useState(quarter);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState(rows);
  const [searchQuery, setSearchQuery] = useState("");
  const [dataFetchFlag, setDataFetchFlag] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (fy_year != "" && quarter != "") {
      handlePreviewClick()
    }
  }, []);
  useEffect(() => {
    setRows([]);
    dispatch({ type: "fy_year", fy_year: selectedFinancialYear });
    dispatch({ type: "quarter", quarter: selectedQuarter });
  }, [selectedFinancialYear, selectedQuarter]);

  const handlePreviewClick = async () => {
    if (previewValidators(selectedFinancialYear, selectedQuarter, false, "", dispatch, pmsName)) {
      dispatch({ type: "SHOW_LOADER" });
      let payload = {
        fy: selectedFinancialYear,
        quarter: selectedQuarter,
        pmsName: ls.get("pmsName"),
        authToken: ls.get("authToken"),
        refreshToken: ls.get("refreshToken")
      }

      const encryptedPayload = await encrypt(payload)
      axios
        .post("/api/pms/settlementPage", { payload: encryptedPayload }, {
          withCredentials: true
        })
        .then((tableData) => {
          if (tableData) {
            let result = tableData.data.value;
            setRows(result);
            setFilteredRows(result);
            dispatch({ type: "HIDE_LOADER" });
          }
          setDataFetchFlag(true);
        })
        .catch((err) => {
          dispatch({ type: "HIDE_LOADER" });
          errorHandler(err, navigate);
          navigate("/app/welcome")
        });
    }
  };
  const handleDownload = async () => {
    const payload = {
      fy_year: selectedFinancialYear,
      quarter: selectedQuarter,
      moduleType:moduleType,
      pmsName: pmsName,
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken")
    }

    const encryptedPayload = await encrypt(payload)
    
    axios
      .post("/api/pms/downloadFile", {
        payload: encryptedPayload
      })
      .then((res) => {
        window.open(res.data.data, "_self");
      })
      .catch((err) => {
        errorHandler(err, navigate);
      })
  };

  const handleSearch = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
    const filteredData = rows.filter((row) => {
      const { id, ...rest } = row;
      return Object.values(rest).some((val) =>
        val?.toString().toLowerCase().includes(query.toLowerCase())
      );
    });
    setFilteredRows(filteredData);
  };

  return (
    <>
      <div className={Styles.FullBody}>
        <div
          className={Styles.navBody}
          style={{}}
        >
          <Breadcrumbs className={Styles.historyNav} aria-label="breadcrumb">
            {/* {ls.get("userType") != "RTA" && */}
              <Link
                underline="hover"
                color="inherit"
                onClick={() => navigate("/app/welcome")}
              >
                Welcome
              </Link>
              {/* } */}
            <Link
              underline="hover"
              color="inherit"
            // href="/app/upload"
            >
              Submission Page
            </Link>
          </Breadcrumbs>
          {rows.length > 0 && (
            <TextField
              style={{
                height: "2rem",
                width: "clamp(10rem,20vw,30rem)",
              }}
              // id="outlined-basic"
              variant="outlined"
              placeholder="Search Table"
              // className="textfield_input"
              value={searchQuery}
              onChange={handleSearch}
            />
          )}
        </div>
        <div className={Styles.HeaderBody}>
          <div>
            <Grid container spacing={2} display="flex">
              <Grid item
                xs={12}
                sm={12}
                md={9}
                lg={9}>
                <SelectComponent
                  selectedFinancialYear={selectedFinancialYear}
                  setSelectedFinancialYear={setSelectedFinancialYear}
                  selectedQuarter={selectedQuarter}
                  setSelectedQuarter={setSelectedQuarter}
                />
              </Grid>
              <Grid
                item
                display="flex"
                xs={12}
                sm={12}
                md={3}
                lg={3}
                className={Styles.dataFormButtonTracker}
                style={{
                  display: "flex",
                  alignItems: "end",
                  justifyContent: "flex-end",
                  gap: "2rem",
                }}
              >
                <button className={Styles.Preview} onClick={handlePreviewClick}>
                  APPLY
                </button>
                {rows.length != 0 && (
                  <button className={Styles.Preview}
                    style={{
                      backgroundColor: rows.length > 0 ? "#154063" : "#808080",
                      cursor: rows.length > 0 ? "pointer" : "default",
                      border: rows.length > 0
                        ? "0.125rem solid #154063" : "0.125rem solid #808080",
                    }}
                    disabled={rows.length > 0 ? false : true}
                    onClick={handleDownload}>DOWNLOAD</button>
                )}
              </Grid>
            </Grid>
          </div>
        </div>
        <div className={Styles.tableBody}>
          {!dataFetchFlag && <Loader />}
          {dataFetchFlag && <SettlementTable rows={filteredRows} />}
          {(pageLoading == false || pageLoading == undefined) && !dataFetchFlag && (
            <img
              className="image"
              src={logo}
              alt="Group 1000000833.png"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default SettlementPage;
